/** @format */

import {useSavedOrdersContext} from './saved_orders_context_provider';
import {useSave} from 'frontier/components/form/use_save';
import {Toast} from '@sttark/design-system';
import {IfElse} from 'frontier-utilities';
import React, {useState} from 'react';

export const ArchiveQuote = props => {
    const ctx = useSavedOrdersContext();
    const {order} = props;

    const [success, setSuccess] = useState(false);

    const {save, isSaving} = useSave('/account/orders/archive-saved');

    const handleRemove = async () => {
        await save({orderId: order.id});
        setSuccess(true);

        ctx.handleRemove(order.id);
    };

    return (
        <>
            <Toast
                onClose={() => setSuccess(false)}
                autoHideDuration={4000}
                isOpen={success}
                zIndex={3001}
                danger
                autoHide>
                <p className="m-0 p-0 color-structure-white">Email sent successfully!</p>
            </Toast>
            <IfElse condition={!isSaving}>
                <button
                    className="d-flex align-items-center justify-content-center gap-2 color-alert-negative"
                    onClick={handleRemove}>
                    <i className="fa fa-trash" />
                    <span>Archive</span>
                </button>
                <button
                    className="d-flex align-items-center justify-content-center gap-2"
                    disabled="disabled">
                    <i className="fa fa-spinner fa-spin" /> <span> Deleting...</span>
                </button>
            </IfElse>
        </>
    );
};
